export { RatingDistributionHistogram } from './RatingDistributionHistogram'
export type { DistributionKey } from './types'
